import { SidebarAppLayout } from './SidebarAppLayout';
import type { NavigationItemType } from '@/types/nav.types';
import { SinglePageAppLayout } from './SinglePageAppLayout';

export function AppLayout({
  navigationItems,
  appName,
}: {
  navigationItems: NavigationItemType[];
  appName?: string;
}) {
  // Show all navigation items in sidebar
  // Access control is handled by ProtectedRoute component
  const showSidebar =
    navigationItems.filter(item => !item.isInternal && item.isProtected)
      .length > 1;

  // Single page layout (no sidebar)
  if (!showSidebar) {
    return <SinglePageAppLayout navigationItems={navigationItems} />;
  }

  // Multi-page layout (with sidebar)
  return (
    <SidebarAppLayout navigationItems={navigationItems} appName={appName} />
  );
}
